import * as React from 'react';
import { File } from '@models/files';
import { getProjectFiles } from '@store/actions/files';
import { useDispatch, useSelector } from 'react-redux';
import { IApplicationState } from '@store/reducer';
import { RequestStatus } from '@store/types';
import Helmet from 'react-helmet';
import { HOCLoader } from '@components';
import { NoFilesMessage } from './NoFilesMessage';
import { FilesTable } from './FilesTable';
import { FilesBreadcrumb } from './FilesBreadcrumb';
import { useTranslation } from 'react-i18next';

export interface IFilesHierarchyStateProps {
  files: File[];
  requestStatus: RequestStatus;
  relativePath: string;
}

const FilesHierarchy: React.FC<IFilesHierarchyStateProps> = ({
  files,
  requestStatus,
  relativePath,
}) => {
  const projectId = useSelector(
    (state: IApplicationState) => state.projectPicker.activeProjectId
  );
  const dispatch = useDispatch();
  const { t } = useTranslation();

  React.useEffect(() => {
    async function loadFiles() {
      if (projectId) {
        dispatch(getProjectFiles(relativePath));
      }
    }
    loadFiles();
  }, [projectId, relativePath]);

  return (
    <div className='files mt-2 clearfix'>
      <Helmet>
        <title>{t('files_title')}</title>
      </Helmet>
      <HOCLoader
        status={requestStatus}
        isEmpty={files.length === 0}
        customEmpty={<NoFilesMessage />}
      >
        <FilesBreadcrumb relativePath={relativePath} />
        <FilesTable data={files} relativePath={relativePath} />
      </HOCLoader>
    </div>
  );
};
export default FilesHierarchy;
